import { NavLink } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'

const IconPOS        = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>
const IconCaja       = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-4 0v2M12 12v3M10 15h4"/></svg>
const IconCategorias = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>
const IconRecepcion  = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M22 12h-6l-2 3h-4l-2-3H2"/><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/></svg>
const IconReportes   = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>
const IconProductos  = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>
const IconUsuarios   = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>
const IconCierres    = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/><path d="M9 16l2 2 4-4"/></svg>
const IconClientes   = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>

export default function Sidebar() {
  const { usuario, logout } = useAuth()
  const iniciales = usuario?.nombre?.split(' ').map(n => n[0]).slice(0,2).join('') || 'U'
  const p = usuario?.permisos || {}
  const esAdmin = p.administrador || usuario?.rol === 'admin'

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <div className="brand-icon"><img src="/logo-redcaja.png" alt="Redcaja"/></div>
        <div>
          <div className="brand-name">Redcaja</div>
          <div className="brand-sub">{usuario?.empresa_nombre || 'Sistema de ventas'}</div>
        </div>
      </div>

      <nav className="sidebar-nav">
        {(p.ventas || p.caja || esAdmin) && (
          <div className="nav-section">
            <div className="nav-section-label">Ventas</div>
            {(p.ventas || esAdmin) && (
              <NavLink to="/pos" className={({isActive}) => `nav-item ${isActive ? 'active' : ''}`}>
                <IconPOS/> Punto de venta
              </NavLink>
            )}
            {(p.caja || esAdmin) && (
              <NavLink to="/caja" className={({isActive}) => `nav-item ${isActive ? 'active' : ''}`}>
                <IconCaja/> Caja
              </NavLink>
            )}
          </div>
        )}

        {(p.inventario || esAdmin) && (
          <div className="nav-section">
            <div className="nav-section-label">Inventario</div>
            <NavLink to="/productos" className={({isActive}) => `nav-item ${isActive ? 'active' : ''}`}>
              <IconProductos/> Productos
            </NavLink>
            <NavLink to="/categorias" className={({isActive}) => `nav-item ${isActive ? 'active' : ''}`}>
              <IconCategorias/> Categorías
            </NavLink>
            <NavLink to="/recepcion" className={({isActive}) => `nav-item ${isActive ? 'active' : ''}`}>
              <IconRecepcion/> Recepción
            </NavLink>
          </div>
        )}

        {(p.clientes || esAdmin) && (
          <div className="nav-section">
            <div className="nav-section-label">Clientes</div>
            <NavLink to="/clientes" className={({isActive}) => `nav-item ${isActive ? 'active' : ''}`}>
              <IconClientes/> Clientes
            </NavLink>
          </div>
        )}

        {(p.reportes || esAdmin) && (
          <div className="nav-section">
            <div className="nav-section-label">Análisis</div>
            <NavLink to="/reportes" className={({isActive}) => `nav-item ${isActive ? 'active' : ''}`}>
              <IconReportes/> Reportes
            </NavLink>
            <NavLink to="/cierres-caja" className={({isActive}) => `nav-item ${isActive ? 'active' : ''}`}>
              <IconCierres/> Cierres de caja
            </NavLink>
          </div>
        )}

        {esAdmin && (
          <div className="nav-section">
            <div className="nav-section-label">Administración</div>
            <NavLink to="/usuarios" className={({isActive}) => `nav-item ${isActive ? 'active' : ''}`}>
              <IconUsuarios/> Usuarios
            </NavLink>
          </div>
        )}
      </nav>

      <div className="sidebar-footer">
        {usuario?.rol === 'superadmin' && (
          <>
            <NavLink to="/superadmin" style={{
              display:'flex', alignItems:'center', gap:'6px', padding:'8px 10px',
              marginBottom:'8px', borderRadius:'6px', fontSize:'12px', fontWeight:600,
              background:'#1a1a2e', color:'white', textDecoration:'none'
            }}>
              ⚙️ Panel Superadmin
            </NavLink>
            <NavLink to="/suscripciones" style={{
              display:'flex', alignItems:'center', gap:'6px', padding:'8px 10px',
              marginBottom:'8px', borderRadius:'6px', fontSize:'12px', fontWeight:600,
              background:'#1a1a2e', color:'white', textDecoration:'none'
            }}>
              💳 Suscripciones
            </NavLink>
          </>
        )}
        <div className="user-card">
          <div className="user-avatar">{iniciales}</div>
          <div className="user-info">
            <div className="user-name">{usuario?.nombre}</div>
            <div className="user-role">{usuario?.rol}</div>
          </div>
          <button
            onClick={logout}
            title="Cerrar sesión"
            style={{
              display: 'flex', alignItems: 'center', gap: '5px',
              background: 'var(--color-danger-bg)',
              border: '1px solid #f7c1c1',
              borderRadius: '6px',
              cursor: 'pointer',
              color: 'var(--color-danger)',
              padding: '6px 10px',
              fontSize: '11px',
              fontWeight: '600',
              whiteSpace: 'nowrap',
              flexShrink: 0,
            }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"/>
            </svg>
            Salir
          </button>
        </div>
      </div>
    </aside>
  )
}
